<script lang="ts">
  interface Props {
    date: string;
  }

  let { date }: Props = $props();

  let timeLeft = new Date(date).getTime() - new Date().getTime();
  let days = $state(Math.floor(timeLeft / (1000 * 60 * 60 * 24)));
  let hours = $state(Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
  let minutes = $state(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)));
  let seconds = $state(Math.floor((timeLeft % (1000 * 60)) / 1000));

  const interval = setInterval(() => {
    timeLeft = new Date(date).getTime() - new Date().getTime();
    days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
  }, 1000);
</script>

<span>
  {#if days > 0}
    {days}d
  {/if}
  {#if hours > 0}
    {hours}h
  {/if}
  {#if minutes > 0}
    {minutes}m
  {/if}
  {#if seconds > 0}
    {seconds}s
  {/if}
</span>
